module.exports = __webpack_public_path__ + "static/media/Mccann.e9425dc4.png";